import Endpoints from '@commons/communication/endpoints.js'
import Gallery from '@commons/util/Gallery.vue'

    export default{
        mixins:[Endpoints],
        components:{
            Gallery
        },
        computed:{
            isWatched:function () {
                var list = this.$store.getters.getWatched;
                list = list.list;

                for (var i = 0; i < list.length; i++) {
                    if (list[i].id == this.product.id){
                        return true;
                    }
                }
                return false;
            },
            isLoggedIn:function () {
                return this.$store.getters.isLoggedIn
            },
        },
        data:function () {
            return {
                product:{},
                showGallery : false,
                categories: [],
                quantity: 1,
                wishObj:{},
            };
        },
        beforeRouteUpdate (to, from, next) {
            next();
            this.init();
        },
        created:function () {
            this.init();
        },
        methods:{
            init:function () {
                var self = this;
                this.categories = [];

                this.connGetProductDetailed(this.$route.params.id,function (r) {
                    self.product = r.data;
                    self.buildCategories(self.product.parentCategory);
                    self.quantity = self.product.additionalFields.minOrderQuantity == 0?1:self.product.additionalFields.minOrderQuantity
                });
            },
            openGallery:function () {
                this.showGallery = true;
            },
            closeGallery:function () {
                this.showGallery = false;
            },
            buildCategories:function (cat) {
                this.categories.unshift(cat);
                // console.log(this.categories);
                if (!cat.root){
                    this.buildCategories(cat.parentCategory);
                }
            },
            addToBasket:function () {
                var o ={
                    product:this.product,
                    quantity:this.quantity
                }

                var self = this;
                this.connBasketAdd(o,function (r) {
                    self.$store.commit('setBasket',r.data);
                    toastr.success('A termék sikeresen hozzá lett adva a kosaradhoz');
                },function (r) {
                    if (r.data.errorCode == 1207){
                        toastr.warning('Túllépted a maximális súlyhatárt.');
                    }
                    if (r.data.errorCode == 1203){
                        toastr.warning('A termékből nem áll rendelkezésre a kívánt mennyiség.');
                    }
                })
            },
            addRemoveWatched:function () {
                var self = this;
                if (!this.isWatched){
                    this.connWatchedAdd(this.product.id,function (r) {
                        self.$store.commit('setWatched',r.data);
                        toastr.success('A termék sikeresen hozzá lett adva a kedvenceidhez');
                    })
                }else{
                    this.connWatchedRemove(this.product.id,function (r) {
                        self.$store.commit('setWatched',r.data);
                        toastr.success('A termék sikeresen hozzá ki lett véve a kedvenceidtől');
                    })
                }
            },
            increment:function () {
                var step = this.product.additionalFields.minOrderQuantity == 0?1:this.product.additionalFields.minOrderQuantity;
                var max = this.product.availableQuantity;

                if (this.quantity+step<=max){
                    this.quantity+=step;
                }
            },
            decrement:function () {
                var step = this.product.additionalFields.minOrderQuantity == 0?1:this.product.additionalFields.minOrderQuantity;

                if (this.quantity-step>=step){
                    this.quantity-=step;
                }
            },
            createNavigationUrl(catId,pgId,propId){
                if (!catId){
                    catId = this.product.parentCategory.id;
                }
                var o = {
                    categoryId: catId,
                }
                if (pgId && propId){
                    o.propertyGroups=[{
                        propertyGroupId: pgId,
                        properties:[propId]
                    }]
                }
                return btoa(JSON.stringify(o));
            },
            addToWishlist(){
                this.wishObj.product = this.product;

                this.connWishlistAdd(!this.isLoggedIn, this.wishObj,function (r) {
                    toastr.success('A vásárlási kérelem elküldve')
                })
            }
        }
    }



// WEBPACK FOOTER //
// ./src/app/main/components/pages/product/ProductDetailed.js